<form [formGroup]="form">
  <div class="container_fieldset">
    <fieldset class="form-group pb-15">
      <legend>Parametri di ricerca</legend>
      <div class="col-xs-12 col-sm-12">
        <div class="row">
          <div *ngFor="let question of questions" [class]="question.size">
            <dynamic-form-field class="form-element" [form]="form" [question]="question"></dynamic-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-12">
            <span class="mandatory">
              <p>
                <em>* Campi obbligatori</em>
              </p>
            </span>
          </div>
          <div class="col-xs-3 col-sm-3">
            <button class="btn btn-secondary reset" type="reset" aria-label="Reset" (click)="onReset()">Reset</button>
          </div>
          <div class="col-xs-3 col-sm-3">
            <button class="btn btn-primary search" type="submit" aria-label="Cerca" (click)="onSearch()" [disabled]="form.invalid">Cerca</button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>

</form>
